import { PaymentStatus } from '../../../types/generalType'
export interface IPreReserveInitialState {
  loading: boolean
  preReserve: {
    loading: boolean
    preReserveList: PreReserveList
    currentPage: number
  }
  undispatchPreReserve: {
    loading: boolean
    preReserveList: Omit<PreReserveList, 'totalPilgrims'>
    currentPage: number
  }
  pilgrimPreReserve: {
    loading: boolean
    pilgrimPreReserveList: PilgrimPerReserveList
  }
  myPreReserves: {
    loading: boolean
    myPreReserveList: PreReserveList
    currentPage: number
  }
  canclePreReserve: {
    loading: boolean
  }
  updateTourKindType: {
    loading: boolean
  }
  deletePreReserve: {
    deletePreReserveLoading: boolean
  }
  dispatchPreReserve: {
    dispatchPreReserveLoading: boolean
  }
  updatePreReserveProvince: {
    updatePreReserveProvinceLoading: boolean
  }
  paymentStatusType: PaymentStatus | null | string
  tourKindType: number | null
  martyrNumber: string
  preReserveId: string
  province:string
  city:string
}

export type THeaderInfo = {
  key: string
  title: string
}
export type Pilgrim = Record<string, any>
// {
//   id: string
//   martyrNumber: string
//   firstName: string
//   lastName: string
//   fatherName: string
//   nationalCode: string
//   birthDate: string
//   ageGroup: string
//   sajayaPrice: number
//   price: number
//   paidPrice: number
//   preReservePaymentStatus: string
//   tourKindType: number
//   transportationType: number
//   hasSajaya: boolean
//   hasLoan: boolean
// }
export type PreReserve = {
  id: string
  preReserveDate: string
  tourKindType: number
  province: string
  city: string
  zone: number
  leaderMobileNumber: string
  leaderPhoneNumber: string
  pilgrims: string | null
  transportationType: number
  preReservePaymentStatus: number
  preReservePaymentStatusDesc: string
  iBan: string | null
  martyrNumber: string | null
}
export type PilgrimPerReserveList = Pilgrim[]
export type PreReserveList = {
  total: number
  data: PreReserve[]
  totalPilgrims: number
}

export enum DispatchStatus {
  ALL = 0,
  UNDISPATCH = 1,
  DISPATCH = 2,
}
